<template>
    <div class="headers">
        <div v-if="ispc">
            <div class="header_wrap">
                <div class="header_left">
                    <img src="../assets/imgs/pclogo.png" alt="" class="img_wrap" @click="goHome">
                    <!--<div class="img_wrap" @click="goHome">-->
                    <!--<img src="../assets/imgs/pclogo.png" alt="">-->
                    <!--</div>-->
                    <ul>
                        <li :class="index == actcon ? 'active':''" v-for="(item,index) in menulist" :key="index" @click="onCon(index,item.url)">{{item.name}}</li>
                    </ul>
                </div>
                <div class="header_right" @click="goChinaUrl">中文版</div>
            </div>
        </div>

        <div class="header_two" v-else>
            <img src="../assets/imgs/h5_nav.png" alt="" class="imgst" @click="onpopshow">
            <div class="himg_wrap" @click="goHome">
                <img src="../assets/imgs/h5_logo.png" alt="">
            </div>
        </div>

        <van-popup v-model="showpopup" position="left" :style="{ width:'70%', height: '100%' }">
            <div class="poptop">
                <img class="poptop_left" src="../assets/imgs/close.png" alt="" @click="onClose">
                <div class="poptop_right">
                    <img class="poptop_right_left" src="../assets/imgs/china.png" alt="">
                    <div class="poptop_right_right" @click="goChinaUrl">中文版</div>
                </div>
            </div>
            <ul class="poplist">
                <li :class="index == actcon ? 'popactive':''" v-for="(item,index) in menulist" :key="index" @click="onCon(index,item.url)">{{item.name}}</li>
            </ul>
        </van-popup>
    </div>
</template>
<script>
  export default {
    name: 'Head',
    data(){
      return{
        menulist: [
          {name:'HOME',url:'home'},
          {name:'NEWS',url:'news'},
          {name:'MARKET',url:'market'},
          {name:'INDEX',url:'index'},
          {name:'EXHIBITON',url:'exhibiton'},
          {name:'ARTIST',url:'artist'}
        ],
        actcon: 0,
        ispc: '',
        showpopup:false
      }
    },
    computed: {
      monitor () {
        return this.$store.state.actcon
      }
    },
    watch: {
      monitor(){
        console.log(this.$route.name);
        this.actcon = this.$store.state.actcon
      }
    },
    methods:{
      goHome(){
        this.$store.state.actcon = 0;
        this.$router.push({name:'home'});
      },
      goChinaUrl(){
        window.location.href = 'https://www.artron.net/';
      },
      onpopshow(){
        this.showpopup = true;
      },
      onClose(){
        this.showpopup = false;
      },
      onCon(index,url){
        this.showpopup = false;
        this.actcon = index;
        this.$store.state.actcon = index;
        this.$router.push({name:url});
      },
      IsPC(){
        var userAgentInfo = navigator.userAgent;
        var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }
        }
        return flag;
      }
    },
    mounted(){
      this.actcon = this.$store.state.actcon;
      this.$store.state.isPc = this.IsPC();
      this.ispc = this.$store.state.isPc;
    },
  }
</script>
<style lang="scss" scoped>
    @media screen and(min-width: 1025px) {
        .headers{
            min-width: 1100px;
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
        }
    }
    @media screen and(max-width: 1024px) {
        .headers{
            box-shadow: 0px 2px 0.1rem 0px rgba(0, 0, 0, 0.1);
        }
    }
    .headers{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 99;
        background: #ffffff;
        .header_wrap{
            height: 80px;
            /*line-height: 80px;*/
            padding: 0 30px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .header_left{
                display: flex;
                align-items: center;
                .img_wrap{
                    width: 180px;
                    height: 32px;
                    margin-right: 20px;
                    cursor: pointer;
                    img{
                        width: 190px;
                        height: 48px;
                    }
                }
                ul{
                    display: flex;
                    align-items: center;
                    li{
                        margin-left: 50px;
                        font-size: 16px;
                        font-family: HelveticaNeue-Bold, HelveticaNeue;
                        font-weight: bold;
                        color: #262626;
                        cursor: pointer;
                    }
                    .active{
                        color: #329D15;
                    }
                }
                ul li:hover{
                    color: #329D15;
                }
            }
            .header_right{
                font-size: 16px;
                color: #595959;
                cursor: pointer;
                &:hover{
                    color: #329D15;
                }
            }
        }
        .header_two{
            height: 2.2rem;
            padding: 0 0.75rem;
            display: flex;
            align-items: center;
            .imgst{
                width: 1rem;
                height: 1rem;
            }
            .himg_wrap{
                margin-left: 0.75rem;
                width: 124px;
                height: 22px;
                vertical-align: initial;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .poptop{
            padding: 0 0.8rem;
            height: 2.65rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .poptop_left{
                width: 0.9rem;
                height: 0.9rem;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .poptop_right{
                display: flex;
                align-items: center;
                .poptop_right_left{
                    width: 0.8rem;
                    height: 0.8rem;
                    img{
                        width: 0.8rem;
                        height: 0.8rem;
                    }
                }
                .poptop_right_right{
                    margin-left: 0.4rem;
                    font-size: 0.7rem;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #595959;
                }
            }
        }
        .poplist{
            border-top: 1px solid #F2F2F2;
            li{
                height: 2.7rem;
                margin-top: 0.4rem;
                padding: 0.8rem 0.75rem;
                font-size: 0.8rem;
                font-family: HelveticaNeue-Bold, HelveticaNeue;
                font-weight: bold;
                color: #000000;
                box-sizing: border-box;
            }
            li:first-child{
                margin-top: 0;
            }
            li:hover{
                background: #EAF5E7;
            }
            .popactive{
                background: #EAF5E7;
            }
        }
    }
</style>
